import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './renewal.reducer';

export const selectRenewalState = createFeatureSelector<State>(featureKey);

export const getRenewalInformationData = createSelector(selectRenewalState, (state: State) => state.renewalInformation);
